import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=42a0548c"
import script from "./BubbleChart.vue?vue&type=script&lang=ts"
export * from "./BubbleChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports